import { css } from "@emotion/core";

export const selfieVideoStyle = css``;
